<template>
  <div class="incentive-page">
    <NavHeaderBar :showSearch="false" :navBarTitle="$t('shared.title.participationRecord')" @backReturn="backReturn">
    </NavHeaderBar>
    <div class="tabs-content">
      <div class="tab-item" :class="{'active-item': tabActive === subItem.value}" v-for="subItem in tabsList" :key="subItem.value" @click="handleTabs(subItem)">{{ subItem.label }}</div>
    </div>
    <!-- Filter Section (Sticky) -->
    <EventFilter
      v-if="tabActive === '1'"
      pageType="incentive"
      :product-options="orderTypeList"
      @filter-change="onFilterChange"
    />

    <!-- Event List -->
    <div class="list-container">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" :finished-text="$t('tips.noMoreData')" @load="onLoad">
          <ProductBind v-if="tabActive === '1'" :incentiveList="incentiveList" />
          <PointsRank v-else :incentiveList="incentiveList" />
        </van-list>
      </van-pull-refresh>
    </div>
    <XuStoreSelect v-model="showStorePicker" @confirm="onConfirmStore" pageType="incentive" />
    <!-- Bottom Button -->
    <div class="bottom-action">
      <van-button class="view-btn" type="info" block @click="toUrl('/incentive/openStoe')">{{ $t('button.viewActivatedStores') }}</van-button>
      <van-button class="invite-btn" type="info" block @click="handleOper">{{ $t('button.inviteStoresToParticipate') }}</van-button>
    </div>

  </div>
</template>

<script>
import { arsActivityOrderActivityRecordApi, activityEmployeeIntegralListApi } from '@/api/incentive'
import { Toast } from 'vant'
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'Incentivedex',
  components: {
    EventFilter: () => import('@/components/EventFilter'),
    XuStoreSelect: () => import('@/components/XuStoreSelect'),
    ProductBind: () => import('./components/productBind'),
    PointsRank: () => import('./components/pointsRank')
  },
  data () {
    return {
      // List State
      incentiveList: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      limit: 10,
      orderTypeList: [
        { label: this.$t('shared.bindProduct'), value: 0 },
        { label: this.$t('shared.uploadSalesReceipt'), value: 2 }
      ],
      // Filter State
      orderType: '', // Changed to array for multiple selection support
      startTime: '',
      endTime: '',
      showStorePicker: false,
      tabsList: [
        { label: this.$t('shared.productBindingRecords'), value: '1' }, // 激励记录
        { label: this.$t('shared.pointsRank'), value: '2' } // 账号管理
      ],
      tabActive: '1'
    }
  },
  computed: {
    ...mapState('event', ['eventInfo']),
    ...mapState({
      globalData: 'globalData'
    })
  },
  activated () {
    const needRefresh = sessionStorage.getItem('EVENT_LIST_NEED_REFRESH')
    if (needRefresh) {
      sessionStorage.removeItem('EVENT_LIST_NEED_REFRESH')
      this.refreshing = true
      this.onRefresh()
    }
  },
  methods: {
    ...mapMutations('event', ['SET_EVENTINFO']),
    onFilterChange (data) {
      this.orderType = data.product
      this.startTime = data.startDate
      this.endTime = data.endDate
      this.refreshing = true
      this.onRefresh()
    },
    handleTabs (params) {
      this.tabActive = params.value
      this.onRefresh()
    },
    // --- API & List Logic ---
    async onLoad () {
      if (this.refreshing) {
        this.incentiveList = []
        this.refreshing = false
      }

      if (this.page === 1) {
        this.incentiveList = []
      }

      try {
        let params = {
          page: this.page,
          limit: this.limit
        }
        if (this.tabActive === '1') {
          params = {
            ...params,
            statusList: [10],
            orderTypeList: [0, 2, 3],
            // Add filter params here, map to actual API fields
            orderType: this.orderType,
            startTime: this.startTime,
            endTime: this.endTime
          }
        }
        Toast.loading({
          message: this.$t('shared.loading'),
          forbidClick: true,
          duration: 0
        })
        const requestApi = this.tabActive === '1' ? arsActivityOrderActivityRecordApi : activityEmployeeIntegralListApi
        const res = await requestApi(params)
        Toast.clear()
        res.data.list.forEach((subItem) => {
          this.globalData.customerJob.find((paramsItem) => {
            if (subItem.job === paramsItem.label && paramsItem.value) {
              subItem.jobColor = JSON.parse(paramsItem.value).color
              return paramsItem
            }
          })
        })
        if (this.refreshing) {
          this.incentiveList = res.data.list
          this.refreshing = false
        } else {
          this.incentiveList = [...this.incentiveList, ...res.data.list]
        }

        this.page++
        if (this.incentiveList.length === Number(res.data.totalRow)) {
          this.finished = true
        }
      } catch (error) {
        console.error(error)
        this.finished = true
      } finally {
        this.loading = false
      }
    },
    onRefresh () {
      this.finished = false
      this.loading = true
      this.page = 1
      this.onLoad()
    },
    toUrl (url, params) {
      if (url === '/eventDetail') {
        this.$router.push(`${url}?eventId=${params.id}&pageType=`)
        this.SET_EVENTINFO({ ...this.eventInfo, eventId: params.id })
      } else {
        this.$router.push(url)
        // this.$destroy()
        this.$destroy()
      }
    },
    backReturn () {
      this.$destroy()
    },
    onConfirmStore (item) {
      this.showStorePicker = false
    },
    handleOper () {
      this.showStorePicker = true
    }
  }
}
</script>

<style lang="less" scoped>
.incentive-page {
  display: flex;
  flex-direction: column;
  background-color: #f7f8fa;
  min-height: 100vh;
  padding-bottom: 80px; // Space for bottom button
  .list-container {
    flex: 1;
  }
  .tabs-content {
    display: flex;
    align-items: center;
    padding: 16px 10px 0;
    background-color: #fff;
    .tab-item {
      padding: 5px 10px;
      border: 1px solid #307bff;
      color: #307bff;
      font-weight: bold;
      font-size: 13px;
    }
    .active-item {
      color: #fff;
      background-color: #307bff;
    }
  }

  // Bottom Button
  .bottom-action {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    display: flex;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    .view-btn {
      background-color: #fff;
      color: #000;
    }
    .invite-btn {
      background-color: #307bff;
    }
    /deep/.van-button {
      border: none;
      border-radius: 0;
      .van-button__text {
        font-weight: bold;
      }
    }
  }
}
</style>
